<div class="container-fluid vh-auto">
  <div class="d-flex justify-content-between align-items-center">
    <h3 class="course-heading text-start">Create New Course</h3>
  </div>
  <p class="sub-head text-start">
    "Create your course step-by-step adding chapters, topics and duration."
  </p>

  <div class="modal-form mb-3">
    <form [formGroup]="createCourseForm">
      <div class="mb-4">
        <label>Course Name <span class="text-danger">*</span></label>
        <input type="text" formControlName="course_title" class="form-control" placeholder="e.g., Science" />
        <small *ngIf="
            createCourseForm.controls['course_title'].hasError('alphanumeric') &&
            createCourseForm.controls['course_title'].touched
          " class="text-danger smaller-text">Only letters and numbers are allowed</small>
      </div>

      <div class="mb-4">
        <label>Course Code <span class="text-danger">*</span></label>
        <input type="text" formControlName="course_code" class="form-control" placeholder="e.g., SC103" />
        <small *ngIf="
            createCourseForm.controls['course_code'].hasError('alphanumeric') &&
            createCourseForm.controls['course_code'].touched
          " class="text-danger smaller-text">
          Please enter a valid course code that must contain numbers or
          letters</small>
      </div>

      <div class="mb-4">
        <label>Grade Level <span class="text-danger">*</span></label>
        <input type="text" formControlName="grade_level" class="form-control" placeholder="e.g., Graduate" />
        <small *ngIf="
            createCourseForm.controls['grade_level'].hasError('alphanumeric') &&
            createCourseForm.controls['grade_level'].touched
          " class="text-danger smaller-text">
          Only letters and numbers are allowed</small>
      </div>

      <div class="row mb-4">
        <div class="col-md-4">
          <label>Credits (Optional)</label>
          <input type="text" formControlName="credits" class="form-control" placeholder="e.g., 4" />
          <small *ngIf="
              createCourseForm.controls['credits'].hasError('number') &&
              createCourseForm.controls['credits'].touched
            " class="text-danger smaller-text">
            Only numeric values are allowed</small>
        </div>

        <div class="col-md-4">
          <label>CIE Marks (Optional)</label>
          <input type="text" formControlName="cie_marks" class="form-control" placeholder="e.g., 50" />
          <small *ngIf="
              createCourseForm.controls['cie_marks'].hasError('number') &&
              createCourseForm.controls['cie_marks'].touched
            " class="text-danger smaller-text">Only numeric values are allowed</small>
        </div>

        <div class="col-md-4">
          <label>SEE Marks (Optional)</label>
          <input type="text" formControlName="see_marks" class="form-control" placeholder="e.g., 40" />
          <small *ngIf="
              createCourseForm.controls['see_marks'].hasError('number') &&
              createCourseForm.controls['see_marks'].touched
            " class="text-danger smaller-text">
            Only numeric values are allowed</small>
        </div>
      </div>
    </form>
  </div>
  <div class="d-flex justify-content-end align-items-end">
    <button type="submit" class="btn-add mb-2" (click)="goToNextPage()" [disabled]="createCourseForm.invalid">
      Next <mat-icon class="icon-middle">chevron_right</mat-icon>
    </button>
  </div>
</div>
